import type { GridItem } from '~sharedLib'
import { BASE_GRID_SCHEMA } from '../constants'

const getGridIndex = (index: number) => {
	return index % BASE_GRID_SCHEMA.length
}

export const getGridSchema = (itemCount: number) => {
	const baseGrid = BASE_GRID_SCHEMA
	const grid: GridItem[] = [{ count: 1, type: 1 }]
	let count = itemCount - 1
	let baseIndex = 0
	while (count > 0 && baseIndex >= 0 && baseIndex < baseGrid.length) {
		if (count === 1) {
			grid.push({ count: 1, type: 2 })
			break
		}

		const current = baseGrid[baseIndex]

		if (
			current && count >= current.count && (count - current.count !== 1)
			&& !(current.count === 2 && count === 4)
			&& !(grid[grid.length - 1]?.count === 3 && count === 6 && current.count === 3)
		) {
			count -= current.count
			grid.push(current)
		}
		baseIndex = getGridIndex(baseIndex + 1)
	}
	return grid
}
